module.exports = __webpack_public_path__ + "img/mainlogo_darkgree_web.a6653c47.png";